module.exports = __webpack_public_path__ + "static/speakers-9d8cb4be8ebf9cef070c64d892623f55.png";